import { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./Cart.scss";
import { useCollection } from "../firebase-files/hooks/useCollection";
import { useDocument } from "../firebase-files/hooks/useDocument";
import useCart from "../firebase-files/hooks/useCart";
import Skeleton from "react-loading-skeleton";
import { useAuthContext } from "../firebase-files/hooks/useAuthContext";
import Popup from "./Popup";
import useOrders from "../firebase-files/hooks/useOrders";
import { Link } from "react-router-dom";
import { useRazorpay } from "../firebase-files/hooks/useRazorpay";
import { Alert } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import ReactPopup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomSnackbar from "./CustomSnackbar";
import OnlinePayment from "./OnlinePayment";
import useNotification from "../firebase-files/hooks/useNotification";
import { useFirestore } from "../firebase-files/hooks/useFirestore";
import { projectFirestore, timestamp } from "../firebase-config/config";

const Cart = () => {
  const navigate = useNavigate();
  const { documents: cartDocuments, error: cartErrors } = useCollection("cart");
  const { documents: productDocuments, error: productErrors } =
    useCollection("products");
  const { document: TAXDocument } = useDocument("settings", "tax_GST");
  const { documents: userDocuments, error: userErrors } =
    useCollection("users");
  const { addDocument } = useFirestore("users");
  const { user } = useAuthContext();
  const { createNotification } = useNotification(); // Import the notification hook
  const { cartItems, updateCartItemQuantity, removeFromCart } = useCart();

  const { createOrder, createAdminOrder } = useOrders();
  const { document: currencyDocument, error: currencyError } = useDocument(
    "settings",
    "currency"
  );

  const { document: paymentMethodDocument } = useDocument(
    "settings",
    "paymentMethod"
  );

  const { document: notificationLifeSpan } = useDocument(
    "m_notifications_setting",
    "visitors"
  );

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [tempSelectedAddress, setTempSelectedAddress] = useState(null);
  const [addressError, setAddressError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [orderLoading, setOrderLoading] = useState(false);
  const { makePayment, paymentResponse } = useRazorpay();
  const [instruction, setInstruction] = useState("");

  const [notificationViewers, setNotificationViewers] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [paymentmethodError, setPaymentMethodError] = useState(false);
  const [searchPhoneNumber, setSearchPhoneNumber] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showNewUserForm, setShowNewUserForm] = useState(false);
  const [newUserName, setNewUserName] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [orderAssignedTo, setOrderAssignedTo] = useState(null);
  const [giftMessages, setGiftMessages] = useState({});

  useEffect(() => {
    // console.log(paymentResponse)
    let totalPayment = Number(1);
    let status = "";
    // console.log('paymentResponse : ', paymentResponse);
    if (paymentResponse) {
      // console.log('paymentResponse.paymentStatus.toUpperCase()', paymentResponse.paymentStatus.toUpperCase())
      status =
        paymentResponse.paymentStatus.toUpperCase() === "SUCCESS"
          ? "Completed"
          : "Pending";
    }
  }, [paymentResponse]);

  async function RazorPayPayment() {
    let orderId = "03948029138";
    let totalPayment = Number(1);

    makePayment(
      orderId,
      // Number(totalPayment),
      1,
      user.userName,
      user.email,
      user.phoneNumber
    ).then(async (e) => {
      console.log(e, "paymentResponse", paymentResponse);
    });
  }

  useEffect(() => {
    if (user?.addresses?.length > 0) {
      const defaultAddr =
        user.addresses.find((address) => address.isDefault) ||
        user.addresses[0];
      setSelectedAddress(defaultAddr);
      setTempSelectedAddress(defaultAddr);
    }
  }, [user]);

  useEffect(() => {
    if (currencyDocument && productDocuments && user && userDocuments) {
      setIsLoading(false);
    }
  }, [currencyDocument, productDocuments, user, userDocuments]);

  useEffect(() => {
    const currentError =
      productErrors || currencyError || cartErrors || userErrors;
    if (currentError) setError(currentError);
  }, [productErrors, currencyError, cartErrors, userErrors]);

  const handleAddressModal = () => {
    setIsAddressModalOpen(true);
  };

  const handleAddressSelection = (address) => {
    setTempSelectedAddress(address);
  };

  const handleSaveAddress = () => {
    setSelectedAddress(tempSelectedAddress);
    setIsAddressModalOpen(false);
  };

  const handlePaymentMethodChange = (method) => {
    setSelectedPaymentMethod(method);
    setPaymentMethodError(false);
  };

  const productMap = useMemo(() => {
    if (!productDocuments) return new Map();
    return new Map(productDocuments.map((p) => [p.id, p]));
  }, [productDocuments]);

  const getProduct = (productId) => productMap.get(productId) || null;

  // const getProduct = (productId) => {
  //   if (!productDocuments) return null;
  //   return productDocuments.find((product) => product.id === productId);
  // };

  const currentProductsInfo = (cartItems) => {
    // console.log("cart items", cartItems);

    if (!cartItems || !Array.isArray(cartItems)) return [];

    return cartItems.reduce((acc, item) => {
      const product = getProduct(item.productId);
      if (!product) return acc;
      return [
        ...acc,
        {
          id: product.id,
          quantity: item.quantity,
          price: product.price,
          discountedPrice: item.discountedPrice || "",
          name: product.name,
          images: product.images || [],
          color: item.color || "",
          size: product.size || "",
          variantName: product.variantName || "",
          category: product.category || "",
          subCategory: product.subCategory || "",
          gst: product.gst || "",
          cgst: product.cgst || "",
          sgst: product.sgst || "",

          // ✅ Add subscription fields
          deliveryInterval: item.deliveryInterval || "",
          selectedFrequencyType: item.selectedFrequencyType || "",
          selectedDeliveryDay: item.selectedDeliveryDay || "",
          selectedDeliveryDate: item.selectedDeliveryDate || "",
        },
      ];
    }, []);
  };

  const handleRemoveFromCart = (cartItemId) => {
    setItemToDelete(cartItemId);
    setPopupMessage("Do you want to remove this item from cart?");
    setShowPopup(true);
  };

  const onRemoveFromCart = useCallback(
    (id) => () => handleRemoveFromCart(id),
    [handleRemoveFromCart]
  );

  const handleQuantityChange = (cartItem, newQuantity) => {
    try {
      if (newQuantity > 0) {
        updateCartItemQuantity(cartItem.id, newQuantity).catch((error) => {
          setSnackbar({
            open: true,
            message: error.message,
            severity: "error",
          });
        });
      } else {
        onRemoveFromCart(cartItem.id)();
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Failed to update quantity",
        severity: "error",
      });
    }
  };

  const handlePopupConfirm = (confirmed) => {
    if (confirmed && itemToDelete) {
      removeFromCart(itemToDelete);
    }
    setShowPopup(false);
    setItemToDelete(null);
  };

  const validateCartItems = async () => {
    const errors = [];

    for (const item of cartItems) {
      const product = getProduct(item.productId);
      if (!product) {
        errors.push(`Product "${item.productId}" is no longer available`);
        continue;
      }

      if (item.quantity > product.stock) {
        errors.push(
          `Only ${product.stock} units available for ${product.name}`
        );
      }

      if (product.minQuantity && item.quantity < product.minQuantity) {
        errors.push(
          `Minimum quantity required for ${product.name} is ${product.minQuantity}`
        );
      }

      if (product.maxQuantity && item.quantity > product.maxQuantity) {
        errors.push(
          `Maximum quantity allowed for ${product.name} is ${product.maxQuantity}`
        );
      }
    }

    return errors;
  };

  useEffect(() => {
    if (notificationLifeSpan) {
      setNotificationViewers(notificationLifeSpan.visibleTo);
    }
  }, [notificationLifeSpan]);

  const handlePlaceOrder = async (
    orderProducts,
    orderPrice,
    address,
    paymentMethod,
    instruction
  ) => {
    // console.log("product details", orderProducts);

    if (!selectedAddress) {
      setAddressError(true);
      return;
    }
    setAddressError(false);

    setOrderLoading(true);
    try {
      const validationErrors = await validateCartItems();
      if (validationErrors.length > 0) {
        setSnackbar({
          open: true,
          message: validationErrors.join(". "),
          severity: "error",
        });
        return;
      }

      if (user.role === "admin") {
        const assignedUser = userDocuments?.find(
          (u) => u.phoneNumber === orderAssignedTo
        );
        if (!orderAssignedTo || !assignedUser) {
          setSnackbar({
            open: true,
            message: "Please assign a valid customer",
            severity: "error",
          });
          return;
        }

        if (!selectedPaymentMethod) {
          setPaymentMethodError(true);
          return;
        }
      }

      const newOrder =
        user.role !== "customer" && orderAssignedTo
          ? await createAdminOrder(
              orderProducts,
              orderPrice,
              address,
              paymentMethod,
              instruction,
              giftMessages,
              orderAssignedTo
            )
          : await createOrder(
              orderProducts,
              orderPrice,
              address,
              paymentMethod,
              instruction,
              giftMessages
            );

      if (newOrder) {
        // console.log("Now Try to adding notification", newOrder);

        // Create a notification after adding a visitor
        await createNotification({
          visibleFor: [
            user.phoneNumber,
            ...(orderAssignedTo ? [orderAssignedTo] : []),
            ...notificationViewers,
          ],
          category: "product order",
          heading: "New Order Placed",
          description: `Order Placed`,
          status: "active",
          link: "/orders",
          lifeSpan: notificationLifeSpan?.notificationSetting?.lifeSpan,
          metaData: {
            userPhone: orderAssignedTo || (user && user.phoneNumber),
            orderId: newOrder.id,
            amount: orderPrice,
            products: orderProducts,
            address,
            paymentMethod,
          },
        });

        navigate(`/ordersummary/${newOrder.id}`);
      } else {
        throw new Error("Failed to create order");
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "Failed to place order",
        severity: "error",
      });
    } finally {
      setOrderLoading(false);
    }
  };

  const groupCartItemsByCategory = () => {
    if (!cartItems || !productDocuments) return {};

    return cartItems.reduce((acc, item) => {
      const product = getProduct(item.productId);
      if (!product) return acc;

      const category = product.category || "Other";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      return acc;
    }, {});
  };

  // console.log(groupCartItemsByCategory());

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const calculateGSTAmount = (gst, price) => {
    if (!gst || typeof gst !== "string") return null;

    const match = gst.match(/[\d.]+/); // e.g., from "6%" or "12.5%"
    if (!match) return 0;

    const gstValue = parseFloat(match[0]);
    const numericPrice = parseFloat(price);

    if (isNaN(gstValue) || isNaN(numericPrice)) return 0;

    return (numericPrice * gstValue) / 100;
  };

  const calculateCartTotal = () => {
    if (!cartItems || !productDocuments) return 0;

    return cartItems.reduce((acc, item) => {
      const product = getProduct(item.productId);
      if (!product) return acc;

      const price = Number(product.price);

      return acc + price * item.quantity; // ✔ multiply actual price
    }, 0);
  };

  const cartTotal = useMemo(
    () => calculateCartTotal(),
    [cartItems, productDocuments]
  );

  const calculateGiftWrapTotal = () => {
    if (!cartItems || !productDocuments) return 0;

    return cartItems.reduce((acc, item) => {
      const product = getProduct(item.productId);
      const giftData = giftMessages[item.id];

      if (
        giftData?.isGift &&
        product?.giftWrapPrice &&
        Number(product.giftWrapPrice) > 0
      ) {
        return acc + Number(product.giftWrapPrice);
      }

      return acc;
    }, 0);
  };

  const giftWrapTotal = useMemo(
    () => calculateGiftWrapTotal(),
    [cartItems, productDocuments, giftMessages]
  );

  

  const extractDiscountValue = (discountString) => {
  if (!discountString) return 0;
  const match = String(discountString).match(/\d+/);
  return match ? Number(match[0]) : 0;
};

const cartDiscount = useMemo(() => {
  if (!cartItems || !productDocuments) return 0;

  return cartItems.reduce((total, item) => {
    const product = getProduct(item.productId);
    if (!product || !product.discount) return total;

    const discountPercent = extractDiscountValue(product.discount);
    const itemTotal = Number(product.price) * item.quantity;

    const discountAmount = (itemTotal * discountPercent) / 100;
    return total + discountAmount;
  }, 0);
}, [cartItems, productDocuments]);

const finalOrderTotal = useMemo(() => {
  return cartTotal - cartDiscount + giftWrapTotal;
}, [cartTotal, cartDiscount, giftWrapTotal]);



  const handleProceedToPayment = () => {
    if (!selectedPaymentMethod) {
      setPaymentMethodError(true);
      return;
    }

    if (!selectedAddress) {
      setAddressError(true);
      return;
    }
    setAddressError(false);

    // Store cart details in localStorage
    localStorage.setItem(
      "cartDetails",
      JSON.stringify({
        orderProducts: currentProductsInfo(cartItems),
        orderPrice: finalOrderTotal,
        selectedAddress,
      })
    );

    // Navigate to payment page
    navigate("/onlinepayment");
  };

  const handlePhoneNumberSearch = () => {
    if (!userDocuments || !searchPhoneNumber) return;

    setIsSearching(true);
    setHasSearched(true);

    const foundUser = userDocuments.find(
      (user) => user.phoneNumber === searchPhoneNumber
    );
    setSelectedUser(foundUser);
    setShowNewUserForm(false);
    setIsSearching(false);
  };

  const handleNewUserClick = () => {
    setShowNewUserForm(true);
    setSelectedUser(null);
    setNewUserName("");
  };

  const handleNewUserSubmit = async (e) => {
    e.preventDefault();
    try {
      const newUser = {
        fullName: newUserName,
        phoneNumber: searchPhoneNumber,
        role: "customer",
        accessType: "country",
        accessValue: "India",
        role: "customer",
        roles: ["customer"],
        status: "active",
        createdAt: timestamp.fromDate(new Date()),
      };

      // console.log(newUser.phoneNumber);

      // Use the phone number as document ID
      await projectFirestore
        .collection("users")
        .doc(newUser.phoneNumber)
        .set(newUser);

      // Set the newly created user as selected user
      setSelectedUser(newUser);

      // Hide the new user form
      setShowNewUserForm(false);

      // Show success message
      setSnackbar({
        open: true,
        message: "User created successfully",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "Failed to create user",
        severity: "error",
      });
    }
  };

  const handleSaveSelectedUser = () => {
    setOrderAssignedTo(selectedUser.phoneNumber);
    setSnackbar({
      open: true,
      message: `Order assigned to ${
        selectedUser.fullName || selectedUser.userName
      }`,
      severity: "success",
    });
  };

  if (!user) {
    return (
      <div className="cart2-page-empty">
        <h2>Please log in to view your cart</h2>
        <Link to="/login">
          <button>Login</button>
        </Link>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cart2-page-empty">
        <h2>Error: {error}</h2>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ height: "100vh", padding: "10px" }}>
        <Skeleton count={5} height={100} className="mb-4" />
      </div>
    );
  }

  // ✅ START CODE FOR GIFT MESSAGE
  // ✅ HANDLE CHECKBOX TOGGLE
  const handleGift = (itemId, checked) => {
    setGiftMessages((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        isGift: checked,
        message: checked ? prev[itemId]?.message || "" : "", // clear message if unchecked
      },
    }));
  };

  const MAX_GIFT_MESSAGE_LENGTH = 200;

  const handleGiftMessage = (itemId, value) => {
    if (value.length > MAX_GIFT_MESSAGE_LENGTH) return;

    setGiftMessages((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        message: value,
      },
    }));
  };

  // ✅ END CODE FOR GIFT MESSAGE
  return (
    <>
      {!cartItems?.length ? (
        <div className="cart2-page-empty">
          <h2>Your Cart is Empty</h2>
          <Link to="/products-two">
            <button>Continue Shopping</button>
          </Link>
        </div>
      ) : (
        <div className="cart2-page">
          {isAddressModalOpen && (
            <div className="address-list-modal-overlay">
              <div className="address-list-modal">
                <div className="address-list-modal-header">
                  <h2>
                    Select Address ( {user.addresses && user.addresses.length} )
                  </h2>
                  <span
                    className="material-symbols-outlined"
                    onClick={() => setIsAddressModalOpen(false)}
                  >
                    close
                  </span>
                </div>

                <div className="address-list-modal-body">
                  {user.addresses && user.addresses.length >= 1 ? (
                    user.addresses.map((address, index) => (
                      <div
                        key={index}
                        className={`address-list-modal-body-single-address ${
                          tempSelectedAddress === address
                            ? "selected-address"
                            : ""
                        }`}
                        onClick={() => handleAddressSelection(address)}
                      >
                        <div className="address-list-modal-body-single-address-type">
                          <span className="material-symbols-outlined">
                            {address.type === "home"
                              ? "home"
                              : address.type === "work"
                              ? "work"
                              : "place"}
                          </span>
                          <span>
                            {address.type.charAt(0).toUpperCase() +
                              address.type.slice(1)}
                          </span>
                        </div>

                        <div className="address-list-modal-body-single-address-details">
                          <h4>{address.name}</h4>
                          <p>
                            {address.houseNumber}, {address.streetLineOne},
                            {address.streetLineTwo &&
                              `${address.streetLineTwo},`}
                            {address.landmark && `${address.landmark},`}
                            {address.city}, {address.pincode}, {address.state},
                            {address.country}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h4>No address found</h4>
                  )}
                </div>

                <div className="address-list-modal-footer">
                  <button onClick={() => navigate("/address")}>
                    Manage More
                  </button>

                  <div>
                    <button onClick={() => setIsAddressModalOpen(false)}>
                      Cancel
                    </button>
                    {user.addresses && user.addresses.length > 1 && (
                      <button onClick={handleSaveAddress}>Save</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="cart2-info">
            <div className="cart2-details">
              <div className="cart2-header">
                <h2>Cart</h2>
                <h2>{cartItems.length} Items</h2>
              </div>
              <div className="cart2-items">
                <div className="cart2-item-header">
                  <span className="cart2-item-product">Product</span>
                  <span className="cart2-item-price">Price</span>
                  <span className="cart2-item-quantity">Quantity</span>
                  <span className="cart2-item-total">Total</span>
                </div>

                {Object.entries(groupCartItemsByCategory()).map(
                  ([category, items]) => (
                    <Accordion
                      key={category}
                      defaultExpanded
                      sx={{
                        margin: "1rem 0",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        "&:before": {
                          display: "none",
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          backgroundColor: "#f8f8f8",
                          width: "100%",
                          "& .MuiAccordionSummary-content": {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "90%",
                            margin: "12px 0",
                          },
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{ color: "#333", flexShrink: 0 }}
                        >
                          {category} ({items.length} items)
                        </Typography>

                        <Typography
                          variant="h6"
                          sx={{
                            color: "#333",
                            marginLeft: "auto",
                            marginRight: "16px",
                          }}
                        >
                          {currencyDocument.symbol}
                          {items.reduce((total, item) => {
                            const product = getProduct(item.productId);
                            return (
                              total +
                              (item.discountedPrice || product.price) *
                                item.quantity
                            );
                          }, 0)}
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails sx={{ padding: "1rem" }}>
                        {items.map((item) => {
                          const product = getProduct(item.productId);
                          if (!product) return null;
                          const giftData = giftMessages[item.id] || {
                            isGift: false,
                            message: "",
                          };

                          return (
                            <>
                              <div className="cart2-item" key={item.id}>
                                <div className="cart2-item-product">
                                  <Link
                                    to={`/product-details-two/${product.id}`}
                                  >
                                    <img
                                      src={product.images[0]}
                                      alt={product.name}
                                    />
                                  </Link>
                                  <div className="cart2-item-detail">
                                    <Link
                                      to={`/product-details-two/${product.id}`}
                                    >
                                      <h3>{product.name}</h3>
                                    </Link>
                                    {(item.color ||
                                      item.size ||
                                      item.variantName) && (
                                      <div className="cart-2-item-variant-info">
                                        <div className="cart-2-item-variant-info-name">
                                          <span>{item.variantName}</span>
                                        </div>

                                        <div>
                                          {item.color && (
                                            <div className="cart-2-item-variant-info-color">
                                              <span>Color:</span>
                                              <div
                                                style={{
                                                  backgroundColor:
                                                    item.color.color,
                                                  borderRadius: "50%",
                                                  width: "15px",
                                                  height: "15px",
                                                  border: "1px solid black",
                                                }}
                                              ></div>
                                            </div>
                                          )}
                                          {item.size && (
                                            <div className="cart-2-item-variant-info-size">
                                              <span>Size: {item.size}</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    <div className="cart2-item-misc-functionality">
                                      <div className="cart2-item-sfl">
                                        <span className="material-symbols-outlined">
                                          bookmark
                                        </span>
                                        <span>Wishlist</span>
                                      </div>
                                      <div
                                        className="cart2-item-remove"
                                        onClick={onRemoveFromCart(item.id)}
                                      >
                                        <span className="material-symbols-outlined">
                                          delete
                                        </span>
                                        <span>Remove</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="cart2-item-actions-container">
                                  <div className="cart2-item-price">
                                    <h5>
                                      {currencyDocument.symbol}
                                      {Number(product.price)
                                        .toFixed(2)
                                        .replace(/\.00$/, "")
                                        .replace(/\.0$/, "")}
                                    </h5>
                                    {product?.gst && product.gst ? (
                                      <div>
                                        <span style={{ fontSize: "13px" }}>
                                          Inclusive of all taxes
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>

                                  <div className="cart2-item-quantityhandler">
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item,
                                          item.quantity - 1
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <span>{item.quantity}</span>
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item,
                                          item.quantity + 1
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>

                                  <div className="cart2-item-itemTotal">
                                    <h5 className="d-flex">
                                      {currencyDocument.symbol}
                                      {product.price * item.quantity}
                                      &nbsp;
                                      <div className="current-price">
                                        {(() => {
                                          const finalPriceWithGST =
                                            product?.price || 0; // stored price is inclusive of GST
                                          const gstValue =
                                            product?.gst !== undefined &&
                                            product?.gst !== null &&
                                            product?.gst !== ""
                                              ? parseFloat(product?.gst)
                                              : parseFloat(
                                                  TAXDocument?.gst || 0
                                                );

                                          const hasValidGST =
                                            !isNaN(gstValue) && gstValue > 0;

                                          // Reverse calculation: Base Price before GST
                                          const basePrice = hasValidGST
                                            ? Math.round(
                                                finalPriceWithGST /
                                                  (1 + gstValue / 100)
                                              )
                                            : finalPriceWithGST;
                                          return (
                                            <div className="d-flex align-items-center">
                                              <ReactPopup
                                                trigger={
                                                  <span
                                                    style={{
                                                      display: "inline-flex",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      height="22px"
                                                      viewBox="0 -960 960 960"
                                                      width="22px"
                                                      fill="grey"
                                                    >
                                                      <path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                                                    </svg>
                                                  </span>
                                                }
                                                position="left"
                                                on="hover"
                                              >
                                                <div
                                                  style={{
                                                    color: "black",
                                                    backgroundColor: "white",
                                                    borderRadius: "7px",
                                                    padding: "15px",
                                                  }}
                                                >
                                                  <strong
                                                    style={{ fontSize: "17px" }}
                                                  >
                                                    Price Details
                                                  </strong>
                                                  <br />

                                                  {/* Base Price * Quantity */}
                                                  <p
                                                    style={{ fontSize: "15px" }}
                                                  >
                                                    Price before GST{" "}
                                                    <b>
                                                      ₹
                                                      {basePrice *
                                                        item.quantity}
                                                    </b>
                                                  </p>

                                                  {/* GST Amount * Quantity */}
                                                  <p
                                                    style={{ fontSize: "15px" }}
                                                  >
                                                    GST ({gstValue}%){" "}
                                                    <b>
                                                      ₹
                                                      {(finalPriceWithGST -
                                                        basePrice) *
                                                        item.quantity}
                                                    </b>
                                                  </p>

                                                  {/* Final MRP * Quantity */}
                                                  <p
                                                    style={{ fontSize: "15px" }}
                                                  >
                                                    Maximum Retail Price{" "}
                                                    <b>
                                                      ₹
                                                      {finalPriceWithGST *
                                                        item.quantity}
                                                    </b>
                                                  </p>

                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      color: "grey",
                                                    }}
                                                  >
                                                    (Inclusive of all taxes)
                                                  </span>
                                                </div>
                                              </ReactPopup>
                                            </div>
                                          );
                                        })()}
                                      </div>
                                    </h5>
                                  </div>
                                </div>
                              </div>
                              {/* ✅ GIFT MESSAGE CHECKBOX PER ITEM */}
                              {product.giftAllow && (
                                <div className="cart-gft-messge-parent">
                                  <div className="d-flex">
                                    <input
                                      type="checkbox"
                                      checked={giftData?.isGift || false}
                                      onChange={(e) =>
                                        handleGift(item.id, e.target.checked)
                                      }
                                    />
                                    &nbsp;
                                    <p style={{ margin: "10px 0px 10px 0px" }}>
                                      Make it special with gift wrapping
                                      🎁&nbsp;
                                      <span>
                                        (
                                        {product.giftWrapPrice &&
                                        Number(product.giftWrapPrice) > 0
                                          ? `₹${product.giftWrapPrice} only`
                                          : "Free of charge"}
                                        )
                                      </span>
                                    </p>
                                  </div>

                                  {/* {giftData.isGift && ( */}
                                  <div>
                                    <TextField
                                      fullWidth
                                      // multiline
                                      minRows={2}
                                      maxRows={4}
                                      label="Gift Message"
                                      placeholder="Write your message (max 200 characters)"
                                      value={giftData?.message || ""}
                                      onChange={(e) =>
                                        handleGiftMessage(
                                          item.id,
                                          e.target.value
                                        )
                                      }
                                      inputProps={{
                                        maxLength: 200,
                                      }}
                                      helperText={`${
                                        (giftData?.message || "").length
                                      } / 200 characters`}
                                      FormHelperTextProps={{
                                        style: {
                                          textAlign: "right",
                                          color:
                                            (giftData?.message || "").length ===
                                            200
                                              ? "red"
                                              : "gray",
                                        },
                                      }}
                                    />
                                  </div>
                                  {/* )} */}
                                </div>
                              )}
                            </>
                          );
                        })}
                      </AccordionDetails>
                    </Accordion>
                  )
                )}
              </div>
            </div>
          </div>

          <div className="cart2-summary-secondary">
            <div className="cart2-summary">
              <h2>Cart Summary</h2>

              <div className="cart2-summary-details">
                <div className="cart2-summary-details">
                  <div className="cart2-summary-order-total">
                    <h5>Cart Total</h5>
                    <h5>
                      {currencyDocument.symbol}
                      {cartTotal}
                    </h5>
                  </div>

                  {giftWrapTotal > 0 && (
                    <div className="cart2-summary-order-shipping">
                      <h5>Gift Wrapping</h5>
                      <h5>
                        {currencyDocument.symbol}
                        {giftWrapTotal}
                      </h5>
                    </div>
                  )}

                  <div className="cart2-summary-order-shipping">
                    <h5>Shipping</h5>
                    <h5>Free</h5>
                  </div>
                </div>

                {/* ✅ Discount label (step 1 only – value later) */}
<div className="cart2-summary-order-discount">
  <h5>Discount</h5>
  <h5 style={{ color: "green" }}>
      -{currencyDocument.symbol}
      {cartDiscount.toFixed(0)}</h5>
</div>


                <hr className="cart2-summary-hr" />
              </div>

              {/* <div className="cart2-summary-final-payment-detail">
                <div className="cart2-summary-final-amount">
                  <h5>Order Total</h5>
                  <h5>
                    {currencyDocument.symbol}
                    {cartTotal}
                  </h5>
                </div>
              </div> */}
              <div className="cart2-summary-final-payment-detail">
                <div className="cart2-summary-final-amount">
                  <h5>Order Total</h5>
                  <h5>
                    {currencyDocument.symbol}
                    {finalOrderTotal}
                  </h5>
                </div>
              </div>

              {user && user.role === "customer" && (
                <>
                  <hr className="cart2-summary-hr" />
                  <div className="cart2-address-details">
                    <div className="cart2-address-header">
                      <h2>Shipping Address</h2>
                      {user.addresses && user.addresses.length >= 1 ? (
                        <span
                          className="material-symbols-outlined"
                          onClick={handleAddressModal}
                        >
                          edit
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="cart2-address-list">
                      {user.addresses && user.addresses.length >= 1 ? (
                        <div className="cart2-single-address">
                          <div className="cart2-single-address-details">
                            <div className="cart2-single-address-info">
                              <h4>
                                {selectedAddress.name}
                                <span>{selectedAddress.type}</span>
                              </h4>
                              <p>
                                {selectedAddress.houseNumber},
                                {selectedAddress.streetLineOne},
                                {selectedAddress.streetLineTwo &&
                                  `${selectedAddress.streetLineTwo},`}
                                {selectedAddress.landmark &&
                                  `${selectedAddress.landmark},`}
                                {selectedAddress.city},{selectedAddress.pincode}
                                ,{selectedAddress.state},
                                {selectedAddress.country}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="add-new-address">
                          <h5>No Addresses Found</h5>
                          <button onClick={() => navigate("/address")}>
                            Add New
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}

              <hr className="cart2-summary-hr" />
              {/* START NEW SECTION */}
              {user && user.role !== "customer" && (
                <>
                  <div className="cart2-customer-search">
                    <h4>Enter Customer Phone Number</h4>
                    {!showNewUserForm ? (
                      <div className="cart2-customer-search-input">
                        <input
                          type="text"
                          value={searchPhoneNumber}
                          onChange={(e) => {
                            setSearchPhoneNumber(e.target.value);
                            setHasSearched(false); // Reset search state when input changes
                            setSelectedUser(null); // Clear selected user when input changes
                          }}
                          placeholder="Enter mobile number"
                        />
                        <button
                          onClick={handlePhoneNumberSearch}
                          className={isSearching ? "searching" : ""}
                          disabled={isSearching}
                        >
                          {isSearching ? "Searching..." : "Search"}
                        </button>
                      </div>
                    ) : null}

                    {selectedUser && !showNewUserForm && (
                      <div className="cart2-customer-search-result">
                        <div className="cart2-customer-card">
                          <h5>
                            {selectedUser.fullName || selectedUser.userName}
                          </h5>
                          <p>{selectedUser.phoneNumber}</p>
                        </div>
                        {!orderAssignedTo && (
                          <button
                            onClick={handleSaveSelectedUser}
                            className="cart2-save-customer-btn"
                          >
                            Assign Order
                          </button>
                        )}
                        {orderAssignedTo === selectedUser.phoneNumber && (
                          <div className="cart2-assigned-badge">
                            <span className="material-symbols-outlined">
                              check_circle
                            </span>
                            <span>Order Assigned</span>
                          </div>
                        )}
                      </div>
                    )}

                    {!selectedUser &&
                      !showNewUserForm &&
                      hasSearched &&
                      searchPhoneNumber && (
                        <div className="cart2-customer-not-found">
                          <span>No user found</span>
                          <button onClick={handleNewUserClick}>New User</button>
                        </div>
                      )}

                    {showNewUserForm && (
                      <form
                        onSubmit={handleNewUserSubmit}
                        className="cart2-new-user-form"
                      >
                        <div>
                          <label>Name:</label>
                          <input
                            type="text"
                            value={newUserName}
                            onChange={(e) => setNewUserName(e.target.value)}
                            required
                          />
                        </div>
                        <div>
                          <label>Phone Number:</label>
                          <input
                            type="text"
                            value={searchPhoneNumber}
                            onChange={(e) =>
                              setSearchPhoneNumber(e.target.value)
                            }
                            required
                          />
                        </div>
                        <div className="cart2-new-user-form-buttons">
                          <button type="submit">Create User</button>
                          <button
                            type="button"
                            onClick={() => setShowNewUserForm(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                  <hr className="cart2-summary-hr" />
                </>
              )}
              {/* END NEW SECTION */}

              {/* INSTRUCTIONS START */}
              <div className="cart2-summary-instructions">
                <h4>Instructions</h4>
                <input
                  type="text"
                  className="cart_two_instructions_input"
                  value={instruction}
                  placeholder="Enter Your Instructions"
                  onChange={(e) => setInstruction(e.target.value)}
                />
              </div>
              {/* INSTRUCTIONS END */}
              <div className="cart2-payment-method">
                <h4>Choose a Payment Method</h4>

                <div className="cart2-payment-method-list">
                  {paymentMethodDocument && paymentMethodDocument.cod && (
                    <div
                      className={`cart2-payment-method-single ${
                        selectedPaymentMethod === "cash"
                          ? "selected-payment-method"
                          : ""
                      }`}
                      onClick={() => handlePaymentMethodChange("cash")}
                    >
                      <div>
                        <span className="material-symbols-outlined">
                          payments
                        </span>
                        <span>Cash</span>
                      </div>
                    </div>
                  )}

                  {paymentMethodDocument && paymentMethodDocument.razorpay && (
                    <div
                      className={`cart2-payment-method-single ${
                        selectedPaymentMethod === "online"
                          ? "selected-payment-method"
                          : ""
                      }`}
                      onClick={() => handlePaymentMethodChange("online")}
                    >
                      <div>
                        <span className="material-symbols-outlined">
                          credit_card
                        </span>
                        <span>Online</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {paymentmethodError && (
                <Alert variant="danger">Please select a payment method</Alert>
              )}
              {addressError && (
                <Alert variant="danger">Please select a delivery address</Alert>
              )}

              {user.addresses && user.addresses.length === 0 ? (
                <div>
                  <button onClick={() => navigate("/address")}>
                    Add Address
                  </button>
                </div>
              ) : selectedPaymentMethod === "cash" ? (
                <>
                  <button
                    onClick={() =>
                      handlePlaceOrder(
                        currentProductsInfo(cartItems),
                        finalOrderTotal,
                        selectedAddress,
                        "cash",
                        instruction
                      )
                    }
                  >
                    {orderLoading ? (
                      <div className="cart2-summary-final-amount-loading">
                        <div className="cart2-summary-final-amount-loading-spinner"></div>
                        <span>Placing Order...</span>
                      </div>
                    ) : (
                      `Place Order for ${currencyDocument.symbol} ${finalOrderTotal}`
                    )}
                  </button>
                </>
              ) : user.role === "admin" ? (
                <button
                  onClick={() =>
                    handlePlaceOrder(
                      currentProductsInfo(cartItems),
                      { cartTotal },
                      selectedAddress,
                      "online",
                      instruction
                    )
                  }
                >
                  {orderLoading ? (
                    <div className="cart2-summary-final-amount-loading">
                      <div className="cart2-summary-final-amount-loading-spinner"></div>
                      <span>Placing Order...</span>
                    </div>
                  ) : (
                    `Place Order for ${currencyDocument.symbol} ${finalOrderTotal}`
                  )}
                </button>
              ) : (
                <button
                  className="cart2-summary-online-ptp"
                  onClick={handleProceedToPayment}
                >
                  <span className="material-symbols-outlined">
                    assured_workload
                  </span>
                  Place Order for {currencyDocument.symbol} {finalOrderTotal}
                </button>
              )}
            </div>
          </div>

          <Popup
            showPopupFlag={showPopup}
            setShowPopupFlag={setShowPopup}
            msg={popupMessage}
            setPopupReturn={handlePopupConfirm}
          />

          <CustomSnackbar
            open={snackbar.open}
            message={snackbar.message}
            severity={snackbar.severity}
            onClose={handleSnackbarClose}
          />
        </div>
      )}
    </>
  );
};

export default Cart;
